module.exports = __webpack_public_path__ + "static/media/inbox-on.a97885b5.svg";